<template>
	<div>
		<div class="pc">
			<el-carousel height="200px">
				<el-carousel-item v-for="(item,index) in data" :key="index">
					<a href="javascript:;" @click="url(item.url)">
						<img :src="item.image" class="item">
					</a>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
	import {
		common_slide
	} from '@/api/common.js';
	export default {
		name: 'indexBanner',
		data() {
			return {
				data: [],
			}
		},
		created() {
			this.get_data();
		},
		methods: {
			get_data() {
				common_slide({
					slide_id: 2
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data;
					}
				});
			},

			url(path) {
				if(!path){
					return false;
				}
				if (path.indexOf("http") != -1) {
					window.location.href = path;
				} else {
					this.$router.push(path);
				}
			}
		}
	}
</script>
<style scoped>
	.pc{
		width: 1300px;
		margin: 0 auto;
		margin-top: 50px;
	}
	.item {
		width: 1300px;
		height: auto;
	}

	/deep/ .el-carousel__arrow--left {
		left: 50px;
	}

	/deep/ .el-carousel__arrow--right {
		right: 50px;
	}

	/deep/ .el-carousel__button {
		background-color: #8a8a8a;
		width: 50px;
		height: 4px;
	}


	/deep/ .el-carousel__indicators--horizontal {
		display: none;
	}
</style>
